import { useEffect } from 'react';

const OPEN_SANS_HREF =
  'https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300..800;1,300..800&display=swap';
// Segoe UI is Windows-only, Open Sans stands in for it elsewhere.
// `body *` beats the global `*` rule but not components that set their own font.
const FONT_RULE = "body * { font-family: 'Segoe UI', 'Open Sans', sans-serif; }";

export const useOpenSansFont = () => {
  useEffect(() => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = OPEN_SANS_HREF;
    const style = document.createElement('style');
    style.textContent = FONT_RULE;
    document.head.append(link, style);

    return () => {
      link.remove();
      style.remove();
    };
  }, []);
};
